<template>
    <div class="monthly-timeline">
        <div class="timeline-container" ref="timeline_width">
            <!-- 头部线条 -->

            <template v-if="dataList.length != 0">
                <span class="text-month">{{ momentmonth + 1 > 12 ? 1 : momentmonth + 1 }} {{ $t('月') }}</span>
                <span class="text-month" style="right: 0;">{{ momentmonth + 2 > 12 ? 1 : momentmonth + 2 }} {{ $t('月')
                    }}</span>
                <div class="timeline-line start-c" :class="{ 'haves': dataList[0].flog != '1' }"
                    :style="getLineStyle1(monthStart, dataList[0].ta_start_time, dataList[0].flog)"></div>

                <div v-for="(event, index) in dataList" :key="index" class="timeline-item"
                    :style="{ left: `${calculatePosition(event.ta_start_time)}px` }">
                    <el-popover placement="top" trigger="hover">
                        <div class="desc-box" @click="handleLink(event)">
                            <span class="fw-b mr-4">{{ handleTime(event.ta_start_time) }}</span>
                            <span class="desc">{{ event.ta_title }}</span>
                        </div>
                        <span class="timeline-span" :class="event.flog == '1' ? '' : 'have'" slot="reference"></span>
                    </el-popover>

                    <div v-if="index < dataList.length - 1" class="timeline-line"
                        :style="getLineStyle(event.ta_start_time, dataList[index + 1].ta_start_time, event.flog)">
                    </div>
                </div>
                <!-- 尾部线条 -->
                <div class="timeline-line end-c" :class="{ 'haves': dataList[dataList.length - 1].flog !== '1' }"
                    :style="getLineStyle1(dataList[dataList.length - 1].ta_start_time, monthEnd, dataList[dataList.length - 1].flog)">
                </div>
            </template>

            <template v-if="dataList.length == 0">
                <span class="text-month">{{ momentmonth + 1 > 12 ? 1 : momentmonth + 1 }} {{ $t('月') }}</span>
                <span class="text-month" style="right: 0;">{{ momentmonth + 2 > 12 ? 1 : momentmonth + 2 }} {{ $t('月')
                    }}</span>
                <div class="timeline-line have start-c"></div>

                <div class="timeline-line have end-c"></div>

            </template>


        </div>
    </div>
</template>

<script>
export default {
    name: 'MonthlyTimeline',

    props: {
        dataList: {
            type: Array,
            // required: true,
            default: () => [{ flog: '1', ta_start_time: '' }] // 默认值
            // default: () => [{ flog: '1', ta_start_time: '' }] // 确保默认值是一个空数组
        },
        timelineWidth: {
            type: Number,
            required: true,
            default: 600,
        }
    },
    data() {
        const currentDate = new Date();
        return {
            monthStart: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
            monthEnd: new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0),

            momentmonth: currentDate.getMonth(),

            // monthStart: new Date('2024-12-01'),
            // monthEnd: new Date('2024-12-31'),
        };
    },
    watch: {
        dataList: {
            handler(newVal, oldVal) {
                const now = new Date(); // 获取当前日期
                this.monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
                this.monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0); // 0 表示上一个月的最后一天

                // 在这里可以添加其他逻辑，比如更新状态或发送请求等
            },
            deep: true // 如果 dataList 是嵌套对象，使用 deep 选项
        }
    },
    mounted() {
        // this.$nextTick(() => {
        //     this.timelineWidth = this.$refs['timeline_width'].clientWidth;
        // })
        // console.log(this.$refs['timeline_width'])
        // 
    },
    methods: {

        // 跳转活动详情
        handleLink(item) {
            let str = '/cn';
            let Language = localStorage.getItem('currentLanguage');  //获取本地语言
            if (Language && Language != 'zh') {
                str = '/' + Language;
            }
            this.$router.push(str + '/activity/info/' + item.ta_id); // 使用编程式导航跳转到 About 页面
        },

        handleTime(date) {
            const today = new Date(); // 获取当前日期
            const target = new Date(date); // 将目标日期转换为 Date 对象

            // 计算时间差（毫秒）
            const timeDiff = target - today;

            // 将时间差转换为天数
            const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

            if (daysDiff > 0) {
                if (daysDiff > 1) {
                    return daysDiff + this.$t('天后s');
                } else {
                    return daysDiff + this.$t('天后');
                }
            } else {
                return '';

            }
        },

        convertToTimestamp(dateInput) {
            // 如果输入是一个有效的 Date 对象，直接获取时间戳
            if (dateInput instanceof Date) {
                return dateInput.getTime();
            }

            // 如果输入是字符串，尝试将其转换为 Date 对象
            const date = new Date(dateInput);

            // 检查日期是否有效
            if (isNaN(date.getTime())) {
                throw new Error('无效的日期格式');
            }

            return date.getTime();
        },


        calculatePosition(date) {
            const eventDate = new Date(date);
            let totalDays = (this.monthEnd - this.monthStart) / (1000 * 60 * 60 * 24);


            let daysFromStart = (eventDate - this.monthStart) / (1000 * 60 * 60 * 24);
            if (daysFromStart > 30) {
                const position = (30 / totalDays) * this.timelineWidth - 8;
                return position;
            }

            const position = (daysFromStart / totalDays) * this.timelineWidth;
            return position;
        },
        getLineStyle(startDate, endDate, flog) {


            const startPos = this.calculatePosition(startDate);
            const endPos = this.calculatePosition(endDate);

            const length = endPos - startPos;


            return {
                backgroundColor: flog === '1' ? '#AEAEAE' : '#B7251E',
                width: `${length}px`,
                // width: `200px`,
                height: '2px', // 线条的高度
                position: 'absolute',
                top: '4px', // 根据需要调整线条的位置
                left: `0px`, // 线条的起始位置
                zIndex: flog === '1' ? 1 : 2 // 确保线条在事件点的后面
            };
        },
        getLineStyle1(startDate, endDate, flog) {
            const startPos = this.calculatePosition(startDate);
            const endPos = this.calculatePosition(endDate);
            const length = endPos - startPos;

            return {
                backgroundColor: flog === '1' ? '#AEAEAE' : '#B7251E',
                width: `${length}px`,
                height: '2px', // 线条的高度
                position: 'absolute',
                top: '4px', // 根据需要调整线条的位置
                left: `${startPos}px`, // 线条的起始位置
                zIndex: -1 // 确保线条在事件点的后面
            };
        }


    },

};
</script>

<style lang="scss" scoped>
.text-month {
    position: absolute;
    bottom: -20px;
    font-size: 14px;
    color: rgb(89, 89, 89);
    font-family: "harmonyos";
}

.monthly-timeline {
    position: relative;
    width: 100%;
    height: 9px;
    margin-bottom: 42.5px;
    margin-top: 48px;

}

.timeline-container {
    position: relative;
    height: 100%;
}

.timeline-item {
    position: absolute;
}

::v-deep() {
    .timeline-span {
        display: inline-block;
        width: 9px;
        height: 9px;
        border-radius: 50%;
        background: rgb(174, 174, 174);
        position: absolute;
        z-index: 10;
        cursor: pointer;
    }

    .timeline-span.have {
        background: rgb(183, 37, 30);
    }

}

.desc-box {
    font-size: 14px;
    line-height: 22px;
    color: #191919;
    cursor: pointer;

    &:hover {
        color: #B7251E;

        .desc {
            color: #B7251E;
        }
    }

    .desc {
        color: #191919;
    }

}

.start-c {
    &::after {
        content: "";
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        border: 0.8px solid rgb(174, 174, 174);
        background: rgb(255, 255, 255);
        position: absolute;
        left: -1px;
        top: -3px;
    }

    &.haves {
        &::after {
            border: 0.8px solid #B7251E;
        }
    }
}

.end-c {
    &::after {
        content: "";
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        border: 0.8px solid rgb(174, 174, 174);
        background: rgb(255, 255, 255);
        position: absolute;
        right: -1px;
        top: -3px;
    }

    &.haves {
        &::after {
            border: 0.8px solid #B7251E;
        }
    }
}


.timeline-content {
    text-align: center;
}
</style>